
<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des créances</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddCreance')">
        <router-link class="btn btn-primary" to="/creances/ajouter-creance">
          <i class="fa fa-plus-circle"></i>
          Ajouter une créance
        </router-link>
      </div>
      <div class="col-md-4" v-if="point_ventes.length > 1">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Filtrer par Point de vente
          </label>
          <div class="d-flex align-items-center" style="width: 200px;">
            <Multiselect 
              v-model="point_vente" 
              :options="point_ventes"  
              :searchable="true" 
              track-by="label" 
              label="label" 
              placeholder="Sélectionner un point de vente" 
            />
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher" class="form-control shadow-none text-black"
            placeholder="Rechercher une creance" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date Créance
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Client
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nbre Echeance
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Montant total
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(creance, index) in creances" :key="index">
              <td class="shadow-none lh-1 fw-medium">{{ format_Date(creance.date) }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ creance?.client.nomClient && creance?.client.prenomClient ? `${creance?.client.nomClient} ${creance?.client.prenomClient}` : creance?.client.raisonSociale }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">{{ creance.nbreEcheance }}</td>
              <td class="shadow-none lh-1 fw-medium">{{ separateur(creance.montant) }}</td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="['badge', getStatutBadge(creance.statut).class]">{{ getStatutBadge(creance.statut).text }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Actions
                </button>
                <ul class="dropdown-menu dropdown-block">
                  <li class="dropdown-item d-flex align-items-center" v-if="checkPermission('ViewCreance')">
                    <router-link :to="{ name: 'ViewCreance', params: { id: creance.id } }" class="dropdown-item d-flex align-items-center">
                      <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                    </router-link>
                  </li>
                  <li class="dropdown-item d-flex align-items-center" v-if="creance.statut === -1 && checkPermission('ValidateCreance')">
                    <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#create-task" @click="openModal(creance.id)">
                      <i class="fa fa-check-circle lh-1 me-8 position-relative top-1"></i>Traiter
                    </a>
                  </li>
                  <li class="dropdown-item d-flex align-items-center" v-if="checkPermission('DeleteCreance')">
                    <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(creance.id, creances, 'creances', `la créance ${creance.id}`)">
                      <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>Supprimer
                    </a>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Voulez-vous traiter cette créance ?</h6>
              <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body px-4">
              <Form ref="creancesForm" @submit="addCreances" :validation-schema="creancesSchema">
                <div class="row gy-2">
                  <div class="col-md-4-3">
                    <label class="d-block fw-semibold mb-10">
                      Observation<span class="text-danger"></span>
                    </label>
                    <Field name="observation" as="textarea" placeholder="Entrer l'observation"
                      class="form-control shadow-none rounded-0 text-black" />
                    <ErrorMessage name="observation" class="text-danger" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">Accepter</button>
                  <button type="button" class="btn btn-danger" @click="rejectCreances" aria-label="Close">
                    Rejeter
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import ApiService from "@/services/ApiService";
import { Form, Field, ErrorMessage } from 'vee-validate';
import { Creance } from "@/models/Creance";
import { format_Date, showModal, hideModal, suppression, error, success, separateur } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Swal from "sweetalert2";
import { useRoute, useRouter } from 'vue-router';
import * as Yup from 'yup';
import Multiselect from "@vueform/multiselect";

export default defineComponent({
  name: "ListeCreance",
  components: {
    PaginationComponent,
    Form,
    Field,
    Multiselect,
    ErrorMessage
  },
  setup() {
    onMounted(async () => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllCreances(point_vente.value);
    });

    const creancesSchema = Yup.object().shape({
      observation: Yup.string().required("L'observation est obligatoire"),
    });
    const creancesForm = ref(null);
    const creances = ref<Array<Creance>>([]);
    const selectedItem = ref(0);
    const creance = ref<Creance>();
    const router = useRouter();
    const route = useRoute();
    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    let point_vente = ref<string>("");
    let point_ventes = ref([]);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllCreances(point_vente.value, page_, limit_);
      } catch (error) {
        //
      }
    };
    const creanceii = ref();
    const openModal = (id: number) => {
      creanceii.value = id;
    };

    watch(point_vente, () => {
      rechercher();
    });

    function rechercher() {
      getAllCreances(point_vente.value, page.value, limit.value, searchTerm.value);
    }

    function getAllCreances(point_vent, page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/creances?page=${page}&limit=${limi}&mot=${searchTerm}&cat=4&pointvente=${point_vent}&`)
        .then(({ data }) => {
          creances.value = data.data.data;
          console.log(data.data.data, "dona")
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const annuleId = (id: number) => {
      selectedItem.value = id;
    };

    const accept = async (creance: any) => {
      const valeur = ref(creance);
      const result = await Swal.fire({
        text: "Etes-vous sur de vouloir accepter cette créance ?",
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Accepter",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
    }

    function triggerButtonClick(buttonId: string) {
      const button = document.getElementById(buttonId) as HTMLButtonElement;
      if (button) {
        button.click();
      } else {
        console.error(`Button with ID "${buttonId}" not found.`);
      }
    }

    const addCreances = async (values, { resetForm }) => {
      values["id"] = creanceii.value;
      values["statut"] = 0; // Passer à "En cours" après traitement
      ApiService.put("/creances/" + values.id, values)
        .then(({ data }) => {
          if (data.code === 200) {
            success(data.message);
            resetForm();
            getAllCreances(point_vente.value);
            triggerButtonClick("close-modal");
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const rejectCreances = async () => {
      const values = {
        id: creanceii.value,
        statut: 3, // Passer à "Rejeté" après rejet (ou autre logique selon vos besoins)
        observation: creancesForm.value?.values?.observation || '',
      };
      ApiService.put("/creances/" + values.id, values)
        .then(({ data }) => {
          if (data.code === 200) {
            success(data.message);
            creancesForm.value?.resetForm();
            getAllCreances(point_vente.value);
            triggerButtonClick("close-modal");
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };


    const getStatutBadge = (statut) => {
      switch (statut) {
        case -1:
          return { class: 'badge badge-light-secondary', text: 'En attente' };
        case 0:
          return { class: 'badge badge-light-warning', text: 'Accepté' };
        case 1:
          return { class: 'badge badge-light-info', text: 'En cours' };
        case 2:
          return { class: 'badge badge-light-success', text: 'Réglé' };
        default:
          return { class: 'badge badge-light-secondary', text: 'Rejeté' };
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return {
      creance,
      openModal,
      creancesForm,
      checkPermission,
      suppression,
      format_Date,
      separateur,
      creances,
      page,
      accept,
      totalPages,
      limit,
      annuleId,
      selectedItem,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher,
      addCreances,
      creancesSchema,
      rejectCreances,
      point_ventes,
      point_vente,
      getStatutBadge
    };
  },
});
</script>
